import { ScheduleInAdvanceEnum } from '../types/VisitorManagementFeatureProperties';

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use scheduleInAdvanceOptions from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export const scheduleInAdvanceOptions = [
  {
    label: ScheduleInAdvanceEnum.One,
    value: 1,
  },
  {
    label: ScheduleInAdvanceEnum.Two,
    value: 2,
  },
  {
    label: ScheduleInAdvanceEnum.Three,
    value: 3,
  },
  {
    label: ScheduleInAdvanceEnum.Four,
    value: 4,
  },
  {
    label: ScheduleInAdvanceEnum.Five,
    value: 5,
  },
  {
    label: ScheduleInAdvanceEnum.Six,
    value: 6,
  },
  {
    label: ScheduleInAdvanceEnum.Seven,
    value: 7,
  },
  {
    label: ScheduleInAdvanceEnum.Eight,
    value: 8,
  },
  {
    label: ScheduleInAdvanceEnum.Nine,
    value: 9,
  },
  {
    label: ScheduleInAdvanceEnum.Ten,
    value: 10,
  },
  {
    label: ScheduleInAdvanceEnum.Eleven,
    value: 11,
  },
  {
    label: ScheduleInAdvanceEnum.Twelve,
    value: 12,
  },
];

/**
 * @deprecated This function is deprecated and should not be used in new code.
 * Use getMaxDateRangeOptions from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export const getMaxDateRangeOptions = (max: number) =>
  scheduleInAdvanceOptions.slice(0, Math.max(max, 1));

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use START_HOUR from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export const START_HOUR = 9;

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use END_HOUR from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export const END_HOUR = 17;
